var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45 37.7",
    style: {
      enableBackground: "new 0 0 45 37.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#827F83;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#827F83;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.8,14.6V7.3h-3.9c-2.2,0-3.6,0-4.7,0.2c-1,0.1-1.5,0.4-1.8,0.7c-0.3,0.3-0.5,0.7-0.7,1.8 c-0.1,1.1-0.1,2.5-0.1,4.7H20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.4,14.6c0-2.2,0-3.6-0.2-4.7c-0.1-1-0.4-1.5-0.7-1.8s-0.7-0.5-1.8-0.7c-1.1-0.2-2.5-0.2-4.7-0.2h-3.9v7.3 C24.2,14.6,35.4,14.6,35.4,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.8,0h-4.5C11.8,0,7.5,0,4.9,2.6C2.6,4.9,2.3,8.5,2.3,15v3.6c-0.9,0.5-1.5,1.3-1.9,2.2 C0,21.6,0,22.7,0,24.8s0,3.1,0.3,4c0.5,1.1,1.3,2,2.4,2.4c0.6,0.2,1.2,0.3,2.3,0.3V36c0,0.9,0.8,1.7,1.7,1.7s1.7-0.8,1.7-1.7v-4.5 h28.1V36c0,0.9,0.8,1.7,1.7,1.7s1.7-0.8,1.7-1.7v-4.5c1,0,1.7-0.1,2.3-0.3c1.1-0.5,2-1.3,2.4-2.4c0.3-0.8,0.3-1.9,0.3-4 s0-3.1-0.3-4c-0.4-0.9-1.1-1.7-1.9-2.2V15c0-6.5-0.3-10-2.6-12.3C37.5,0,33.2,0,24.8,0L24.8,0z M38.8,18v-3.5c0-2,0-3.7-0.2-5.1 C38.4,8.1,38,6.8,37,5.8s-2.3-1.4-3.7-1.6c-1.3-0.2-3-0.2-5-0.2H16.8c-2,0-3.7,0-5.1,0.2C10.3,4.3,9,4.7,8,5.8S6.6,8.1,6.4,9.5 c-0.2,1.3-0.2,3-0.2,5.1V18c0.2,0,0.4,0,0.6,0h31.5C38.5,18,38.6,18,38.8,18z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.c74a393196d18844c045db26f48d4981.svg";
export { ForwardRef as ReactComponent };